import type { IntlShape } from "react-intl";

/** Missing or non-finite amounts render as zero, never "$NaN". */
export const formatCurrency = (
  amount: number | undefined,
  intl: IntlShape,
  currency: string,
): string =>
  intl.formatNumber(
    typeof amount === "number" && Number.isFinite(amount) ? amount : 0,
    { style: "currency", currency },
  );
